import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { WorkOrderItemData } from '..';
import { useState } from 'react';
import CommissionListModal from '../../Commission/CommissionListModal';
import { useDisclosure } from '@/hooks';
import ActionIcon from '@/components/_common/ActionIcon';
import { Popover } from 'antd';
import { Percent } from 'react-feather';

interface Props {
  workOrderItem: WorkOrderItemData;
}

export default function WorkOrderItemCommision(props: Props) {
  const { workOrderItem } = props;

  const [commissionItem, setCommisionItem] = useState<WorkOrderItemData>();

  const [modalOpened, modalAction] = useDisclosure();

  const disabled =
    workOrderItem.type === WorkOrderItemType.Kit ||
    workOrderItem.type === WorkOrderItemType.Benefit ||
    workOrderItem.type === WorkOrderItemType.Bosch ||
    workOrderItem.type === WorkOrderItemType.Porto ||
    !hasPermissions([
      Authorities.MOVIMENTATION_WORKORDER_VIEW_COMMISSIONS_PAYMENT,
    ]);

  return (
    <>
      <Popover content="Comissão">
        <div>
          <ActionIcon
            disabled={disabled}
            onClick={() => {
              setCommisionItem(workOrderItem);
              modalAction.open();
            }}
          >
            <Percent
              color={workOrderItem.haveCommission ? '#2ac72a' : undefined}
              size={20}
            />
          </ActionIcon>
        </div>
      </Popover>

      <CommissionListModal
        open={modalOpened}
        onCancel={modalAction.close}
        itemId={commissionItem?.id}
        item={commissionItem}
        quantity={commissionItem?.quantity}
      />
    </>
  );
}
